module.exports = __webpack_public_path__ + "media/images/reports/tax_return-8c62f6754f6c18cd79beda1e3c022cbe.svg";